import { z } from "zod";

export const newFolderFormSchema = z.object({
	title: z.string().trim().min(1),
});

export type NewFolderFormInput = z.input<typeof newFolderFormSchema>;
export type NewFolderFormOutput = z.output<typeof newFolderFormSchema>;
